import { Button, Tab, Tabs, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import RbacAccessDeniedPage from '~/components/communication/RbacAccessDeniedPage'
import { Can } from '~/utils/ability'
import TabPanel from '../../../components/containers/TabPanel'
import PlusIcon from '../../../components/icons/PlusIcon'
import Page from '../../../components/Page'
import { EstablishmentsPanel } from '../../../components/routes/sellers/EstablishmentsPanel'
import { SellersPanel } from '../../../components/routes/sellers/SellersPanel'
import { useRights } from '../../../utils/hooks'
import { fonts } from '../../../utils/theme/fonts.theme'
const tabs = ['sellers', 'establishments'] as const

export const Route = createFileRoute('/_authenticated/sellers/')({
  component: () => (
    <Can I="read" a="sellers" passThrough>
      {({ isAllowed }) => (isAllowed ? <SellersPage /> : <RbacAccessDeniedPage />)}
    </Can>
  ),
  validateSearch: z.object({
    tab: z.enum(tabs).optional(),
  }),
})

function SellersPage() {
  const isAdmin = useRights(['ADMIN'])

  const { tab = 'sellers' } = Route.useSearch()

  const navigate = Route.useNavigate()

  const handleChange = (newValue: number) => {
    const newTab = tabs.at(newValue)
    navigate({ search: { tab: newTab } })
  }

  return (
    <Page>
      <div style={{ display: 'flex' }}>
        <Typography style={fonts.pageTitle} flexGrow={1}>
          Vendeurs
        </Typography>

        {tab === 'sellers' && (
          <Button
            variant="contained"
            onClick={() => navigate({ to: '/sellers/new' })}
            disabled={!isAdmin}
          >
            <PlusIcon />
            Ajouter un vendeur
          </Button>
        )}
        {tab === 'establishments' && (
          <Button
            variant="contained"
            onClick={() => navigate({ to: '/sellers/establishment/new' })}
            disabled={!isAdmin}
          >
            <PlusIcon />
            Ajouter un établissement
          </Button>
        )}
      </div>

      <Tabs value={tabs.indexOf(tab)} onChange={(_, newValue) => handleChange(newValue)}>
        <Tab label="Vendeurs" />
        <Tab label="Établissements" />
      </Tabs>

      <TabPanel value={tab} index="sellers">
        <SellersPanel />
      </TabPanel>

      <TabPanel value={tab} index="establishments">
        <EstablishmentsPanel />
      </TabPanel>
    </Page>
  )
}
